import Vue from "vue";
import App from "./App.vue";
import element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import axios from "axios";
import VueAxios from "vue-axios";
import VueRouter from 'vue-router'
//import { createMemoryHistory, createRouter } from "vue-router";
import router from "./router";
//import  './js/base64.js';
Vue.config.productionTip = false;
Vue.use(element);
Vue.use(VueAxios, axios);
Vue.use(VueRouter);
new Vue({
  render: (h) => h(App),
  router: router,
}).$mount("#app");
